<template>
  <Teleport to="body">
    <div
      v-if="modelValue"
      id="layup-terms-modal"
      class="fixed inset-0 z-50 flex items-start sm:items-center justify-center"
      style="background-color: rgba(55, 65, 81, 0.85)"
    >
      <div
        class="relative bg-white w-full h-full sm:h-[80vh] sm:max-w-lg sm:mx-4 sm:rounded-2xl flex flex-col overflow-hidden"
      >
        <div
          class="sticky top-0 z-10 bg-white flex items-center justify-between px-6 sm:px-8 py-4 border-b border-gray-100"
        >
          <span class="text-sm font-semibold text-gray-800">{{ title ?? 'LayUp Terms &amp; Conditions' }}</span>
          <button
            class="w-9 h-9 rounded-full bg-gray-100 hover:bg-gray-200 transition-colors flex items-center justify-center"
            aria-label="Close"
            @click="$emit('update:modelValue', false)"
          >
            <X class="w-4 h-4 text-gray-700" />
          </button>
        </div>
        <div :class="noPadding ? 'flex-1 overflow-hidden' : 'overflow-y-auto flex-1 px-6 pt-6 pb-10 sm:px-8'">
          <slot />
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { X } from 'lucide-vue-next';

defineProps<{ modelValue: boolean; noPadding?: boolean; title?: string }>();
defineEmits<{ (e: 'update:modelValue', value: boolean): void }>();
</script>
